module.exports = __webpack_public_path__ + "static/img/04.67b7f6f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/apps/gamify/tutorial/04.svg
// module id = baqS
// module chunks = 13